module.exports = "<div class=\"row bgHeading\"><h2>Whats up for grabs</h2></div>\n<div class=\"col-12\">\n  <div class=\"col-12\" [innerHtml]=\"intro\"></div>\n  <div class=\"col-12\" [innerHtml]=\"body\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/prizes/prizes.component.html
// module id = 327
// module chunks = 1